import React, { useState, useEffect } from 'react';
import ProgramsListView from '../../views/ver_24.10/ProgramsList.view';
import Loader from "../../ui_library/ver_24.10/Loader/Loader.comp";
import {
    createProgramService,
    fetchAllProgramsService,
    removeProgramService,
} from "../../services/program.service";
import {useHistory} from "react-router-dom";
import {PBDQ3_PROGRAM_STATE} from "../../utils/constants";

const ProgramsList = () => {
    const history = useHistory();
    const [showLoader, setShowLoader] = useState(false);
    const [programs, setPrograms] = useState([]);

    useEffect(() => {
        setShowLoader(true);
        initializeFetchAllPrograms().then(resp => setShowLoader(false)).catch(err => setShowLoader(false));
    }, []);

    const initializeFetchAllPrograms = async () => {
        setShowLoader(true);
        try {
            const result = await fetchAllProgramsService();
            if (result && result.data) {
                console.log('programs_fetched: ', result.data.all_programs);
                setPrograms(result.data.all_programs);
            }

        } catch (e) {
        // already toasted the error
        }
        setShowLoader(false);
    };

    const data = {
        programs,
    };

    const actions = {

        createProgramAction: () => {
            history.push(`/program/new`);
        },

        removeProgramAction: async (programId) => {
            setShowLoader(true);
            try {
                const result = await removeProgramService(programId);
                if (result && result.data) {
                    console.log(result.data.message);
                    console.log('programs_fetched: ', result.data.all_programs);
                    setPrograms(result.data.all_programs);
                }
            } catch (e) {

            }
            setShowLoader(false);
        },

        viewProgramAction: (programId, program_status) => {
            if (programId && program_status <= PBDQ3_PROGRAM_STATE.PROGRAM_DRAFT ) {
                history.push(`/program/new?programId=${programId}`);
            } else {
                history.push(`/program/${programId}/dashboard`);
            }
        },
    };

    const options = {
    };

    if (showLoader) {
        return <Loader />;
    }

    return (
        <>
            <div>
                <ProgramsListView data={data} actions={actions} options={options}/>
            </div>
        </>
    );
}

export default ProgramsList;